import { createReducer, on } from '@ngrx/store';
import {
  reloadOccupationDetailsSuccess,
  occupationDetailWithBusinessRulesReady,
  clearOccupationDetail,
  loadOccupationForExportPdf,
  loadOccupationForExportPdfSuccess,
  loadOccupationFailed,
  loadOccupationError,
  clearOccupationDetailFor,
  clearOccupationForExportPdf
} from './occupation-detail.actions';

import { initialState, occupationKey } from './occupation-detail.state';

export const reducer = createReducer(
  initialState,

  on(occupationDetailWithBusinessRulesReady, (state, { occupationDetail }) => ({
    ...state,
    occupationDetail,
    occupationLoadFailure: null
  })),

  on(reloadOccupationDetailsSuccess, (state, { occupationDetail }) => ({
    ...state,
    occupationDetail,
    occupationLoadFailure: null
  })),

  on(clearOccupationDetail, (state) => ({
    ...state,
    occupationDetail: undefined,
    occupationLoadFailure: null
  })),

  on(clearOccupationDetailFor, (state, { onetCode, jobId }) => {
    const key = occupationKey(onetCode, jobId);
    const detail = state.occupationDetail;
    const detailIsThisPage =
      !!detail && occupationKey(detail.onetCode, detail.jobId) === key;
    return {
      ...state,
      occupationDetail: detailIsThisPage ? undefined : detail,
      occupationLoadFailure:
        state.occupationLoadFailure?.key === key
          ? null
          : state.occupationLoadFailure
    };
  }),

  on(loadOccupationForExportPdf, (state) => ({
    ...state
  })),

  on(loadOccupationForExportPdfSuccess, (state, { occupation }) => ({
    ...state,
    occupationForExportPdf: occupation
  })),

  // Audit 30 Sep: /occupation/<bad code> spun forever, because nothing
  // recorded that the load had come back empty.
  on(loadOccupationFailed, (state, { onetCode, jobId }) => ({
    ...state,
    occupationLoadFailure: {
      key: occupationKey(onetCode, jobId),
      kind: 'not-found' as const
    }
  })),

  // Code review, 30 Sep: a server error is not "not found".
  on(loadOccupationError, (state, { onetCode, jobId }) => ({
    ...state,
    occupationLoadFailure: {
      key: occupationKey(onetCode, jobId),
      kind: 'error' as const
    }
  })),

  on(clearOccupationForExportPdf, (state) => ({
    ...state,
    occupationForExportPdf: undefined
  }))
);
